import { IsNotEmpty, IsNumberString } from 'class-validator';

export class RouteTeamTypeDTO {

    @IsNotEmpty()
    @IsNumberString()
    type: string;

}
